import { NgModule } from '@angular/core';

import { MzToastService } from './services/index';

@NgModule({
  providers: [MzToastService],
})
export class MzToastModule { }
